import { render, staticRenderFns } from "./Citation.vue?vue&type=template&id=1da0dfc9"
import script from "./Citation.vue?vue&type=script&lang=js"
export * from "./Citation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports